export default {
  '/barcode-wizard': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
  ],
  '/new-label': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
    {url: '/barcode-label', title: 'barcode.utils.header-links.barcode-label'},
  ],
  '/edit-label/:id': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
    {url: '/barcode-label', title: 'barcode.utils.header-links.barcode-label'},
  ],
  '/barcode-library': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-library', title: 'barcode.utils.header-links.library'},
  ],
  '/barcode_generator': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
  ],
  '/barcode-wizard-auto-form': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
    {
      url: '/barcode-wizard-auto-form',
      title: 'barcode.utils.header-links.automatic-generator',
    },
  ],
  '/barcode-wizard-field-value-form': [
    {
      url: '/barcode_generator',
      title: 'barcode.utils.header-links.barcode-generator',
    },
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
    {
      url: '#',
      title: 'barcode.utils.header-links.field-value',
    },
  ],
  '/barcode-wizard-generate-field-value': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
    {url: '/barcode-wizard-field-value-form', title: 'barcode.utils.header-links.field-value'},
    {
      url: '/barcode-wizard-generate-field-value',
      title: 'barcode.utils.header-links.select-items',
    },
  ],
  '/barcode-libray-reprint': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
  ],
  '/barcode-library-preview': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
  ],
  '/barcode-libray-generate-automatic': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
  ],
  '/barcode-wizard-generate-automatic': [
    {url: '/barcode_generator', title: 'barcode.utils.header-links.barcode-generator'},
    {url: '/barcode-wizard', title: 'barcode.utils.header-links.barcode-wizard'},
    {url: '/barcode-wizard-auto-form', title: 'barcode.utils.header-links.automatic-generator'},
    {url: '/barcode-wizard-generate-automatic', title: 'barcode.utils.header-links.summary'},
  ],
}
